import MapStoreProps, {
    MapStoreOpenHours,
    MapStoreSpecialHours,
} from "../../types/MapStore";
import MapUtils from "./MapUtils";

class MapStore {
    mapContainer: HTMLElement | null;
    utils: MapUtils;
    siteTheme: string;
    config: {
        OPENING_HOURS: {
            UNASSIGNED: number;
            SAME_ALL_WEEK: number;
            SAME_WEEKDAY_SAME_WEEKEND: number;
            SAME_WEEKDAY_DIFFERENT_WEEKEND: number;
            DIFFERENT_WEEKDAY: number;
        };
        WEEKDAY_LANGUAGE: string;
        ALL_DAYS_LABEL: string;
        MON_FRI_LABEL: string;
        WEEKEND_LABEL: string;
        SAT_LABEL: string;
        SUN_LABEL: string;
        HOURS_UNASSIGNED: string;
        CLOSED_LABEL: string;
        WEEKDAY_LABELS: string[];
        GOOGLE_MAPS_BASE_URL: string;
    };

    constructor() {
        this.mapContainer = document.getElementById("map");
        this.utils = new MapUtils();
        this.siteTheme = this.mapContainer?.dataset.siteTheme || "";
        this.config = {
            OPENING_HOURS: {
                UNASSIGNED: 0,
                SAME_ALL_WEEK: 1,
                SAME_WEEKDAY_SAME_WEEKEND: 2,
                SAME_WEEKDAY_DIFFERENT_WEEKEND: 3,
                DIFFERENT_WEEKDAY: 4,
            },
            WEEKDAY_LANGUAGE: "sv-SE",
            ALL_DAYS_LABEL: "alla dagar",
            MON_FRI_LABEL: "mån-fre",
            WEEKEND_LABEL: "helg",
            SAT_LABEL: "lör",
            SUN_LABEL: "sön",
            HOURS_UNASSIGNED: "ingen uppgift",
            CLOSED_LABEL: "Stängt",
            WEEKDAY_LABELS: [
                "Måndag",
                "Tisdag",
                "Onsdag",
                "Torsdag",
                "Fredag",
                "Lördag",
                "Söndag",
            ],
            GOOGLE_MAPS_BASE_URL:
                "https://www.google.com/maps/search/?api=1&query=" +
                this.siteTheme +
                "+",
        };
    }

    setOpeningHours(store: MapStoreProps) {
        const openingSets = this.getNumberOfOpeningDaySets(store);

        $("#set-1").hide();
        $("#set-2").hide();
        $("#set-3").hide();
        $("#set-4").hide();
        $("#set-5").hide();

        const setOneOpening = this.getOpeningTime(store.OpenHours, "Mon");
        const setOneClosing = this.getClosingTime(store.OpenHours, "Mon");
        const setTwoOpening = this.getOpeningTime(store.OpenHours, "Sat");
        const setTwoClosing = this.getClosingTime(store.OpenHours, "Sat");
        const setThreeOpening = this.getOpeningTime(store.OpenHours, "Sun");
        const setThreeClosing = this.getClosingTime(store.OpenHours, "Sun");

        switch (openingSets) {
            case this.config.OPENING_HOURS.UNASSIGNED: {
                $("#set-4").show();
                $("#set-4-day").text(this.config.ALL_DAYS_LABEL);
                $("#no-hours").text(this.config.HOURS_UNASSIGNED);
                break;
            }

            case this.config.OPENING_HOURS.SAME_ALL_WEEK: {
                $("#set-1").show();
                $("#set-1-day").text(this.config.ALL_DAYS_LABEL);
                $("#set-1-hours-open").text(this.getHours(setOneOpening) || "");
                $("#set-1-hours-open").attr(
                    "data-after",
                    this.getMinutes(setOneOpening),
                );
                $("#set-1-hours-closing").text(
                    this.getHours(setOneClosing) || "",
                );
                $("#set-1-hours-closing").attr(
                    "data-after",
                    this.getMinutes(setOneClosing),
                );
                break;
            }

            case this.config.OPENING_HOURS.SAME_WEEKDAY_SAME_WEEKEND: {
                $("#set-1").show();
                $("#set-2").show();
                $("#set-1-day").text(this.config.MON_FRI_LABEL);
                $("#set-1-hours-open").text(this.getHours(setOneOpening) || "");
                $("#set-1-hours-open").attr(
                    "data-after",
                    this.getMinutes(setOneOpening),
                );
                $("#set-1-hours-closing").text(
                    this.getHours(setOneClosing) || "",
                );
                $("#set-1-hours-closing").attr(
                    "data-after",
                    this.getMinutes(setOneClosing),
                );

                $("#set-2-day").text(this.config.WEEKEND_LABEL);
                $("#set-2-hours-open").text(this.getHours(setTwoOpening) || "");
                $("#set-2-hours-open").attr(
                    "data-after",
                    this.getMinutes(setTwoOpening),
                );
                $("#set-2-hours-closing").text(
                    this.getHours(setTwoClosing) || "",
                );
                $("#set-2-hours-closing").attr(
                    "data-after",
                    this.getMinutes(setTwoClosing),
                );
                break;
            }

            case this.config.OPENING_HOURS.SAME_WEEKDAY_DIFFERENT_WEEKEND: {
                $("#set-1").show();
                $("#set-2").show();
                $("#set-3").show();

                $("#set-1-day").text(this.config.MON_FRI_LABEL);
                $("#set-1-hours-open").text(this.getHours(setOneOpening) || "");
                $("#set-1-hours-open").attr(
                    "data-after",
                    this.getMinutes(setOneOpening),
                );
                $("#set-1-hours-closing").text(
                    this.getHours(setOneClosing) || "",
                );
                $("#set-1-hours-closing").attr(
                    "data-after",
                    this.getMinutes(setOneClosing),
                );

                if (setThreeOpening === setThreeClosing) {
                    $("#set-3-closed").show();
                    $("#set-3-open").hide();
                    $("#set-3-hours-closed").text(this.config.CLOSED_LABEL);
                } else {
                    $("#set-3-open").show();
                    $("#set-3-closed").hide();
                }

                $("#set-2-day").text(this.config.SAT_LABEL);
                $("#set-2-hours-open").text(this.getHours(setTwoOpening) || "");
                $("#set-2-hours-open").attr(
                    "data-after",
                    this.getMinutes(setTwoOpening),
                );
                $("#set-2-hours-closing").text(
                    this.getHours(setTwoClosing) || "",
                );
                $("#set-2-hours-closing").attr(
                    "data-after",
                    this.getMinutes(setTwoClosing),
                );

                $("#set-3-day").text(this.config.SUN_LABEL);
                $("#set-3-hours-open").text(
                    this.getHours(setThreeOpening) || "",
                );
                $("#set-3-hours-open").attr(
                    "data-after",
                    this.getMinutes(setThreeOpening),
                );
                $("#set-3-hours-closing").text(
                    this.getHours(setThreeClosing) || "",
                );
                $("#set-3-hours-closing").attr(
                    "data-after",
                    this.getMinutes(setThreeClosing),
                );
                break;
            }

            case this.config.OPENING_HOURS.DIFFERENT_WEEKDAY: {
                $("#set-5").show();
                const labels = this.config.WEEKDAY_LABELS.map(
                    (weekdayLabel: string): string =>
                        `<li><span class='label'>${weekdayLabel}</span><span class='time-span'>${this.getTimeSpan(
                            store.OpenHours,
                            this.getWeekday(weekdayLabel),
                        )}</span></li>`,
                );

                $("#opening-hours-list").empty().append(labels.join(""));
                break;
            }
        }
    }

    setSpecialOpeningHours(store: MapStoreProps) {
        if (store.SpecialHours) {
            $("#special-hours").show();
            $("#special-hours li").each((i, listElem) => {
                $(listElem).remove();
            });
            store.SpecialHours.forEach((d: MapStoreSpecialHours) => {
                // The API already limits SpecialHours to the active visibility window, including today.
                $("#special-hours-list").append(
                    `<li><span class='label special-hours-day'>${this.getSpecialDay(d)}</span><span class='time-span'>${this.getSpecialHours(d)}</span></li>`,
                );
            });
        }
        if (
            !store.SpecialHours ||
            $("#special-hours-list").children().length === 0
        ) {
            $("#special-hours").hide();
        }
    }

    setUnmannedOpeningHours(store: MapStoreProps) {
        $("#unmanned-hours-list").empty();

        const hasUnmannedHours = !!store.UnmannedHours.length;

        if (hasUnmannedHours) {
            $("#unmanned-hours").show();
            store.UnmannedHours.forEach((item) => {
                $("#unmanned-hours-list").append(`<li>${item}</li>`);
            });
        } else {
            $("#unmanned-hours").hide();
        }
    }

    handleOpeningHoursBorderLine(store: MapStoreProps) {
        const openingHoursElement = document.getElementById(
            "store-opening-hours",
        );
        const openingHoursTwoColumnsElement = document.getElementById(
            "opening-hours-two-columns",
        );
        if (store.UnmannedHours.length || store.SpecialHours?.length) {
            openingHoursElement?.classList.remove("border-line");
            openingHoursTwoColumnsElement?.classList.add("has-underline");
        } else {
            openingHoursElement?.classList.add("border-line");
            openingHoursTwoColumnsElement?.classList.remove("has-underline");
        }
    }

    setStoreServices(store: MapStoreProps) {
        if (store.StoreServices) {
            $("#store-services").show();
            $("#store-services li").each((i, listElem) => {
                $(listElem).remove();
            });

            store.StoreServices.forEach((service) => {
                $("#store-services-list").append("<li>" + service + "</li>");
            });
        } else {
            $("#store-services").hide();
        }
    }

    setSocialInfo(store: MapStoreProps) {
        if (store.StoreLink) {
            $("#store-find-page").attr("href", store.StoreLink);
        } else {
            $("#store-find-page").hide();
        }
    }

    setContactInfo(store: MapStoreProps) {
        if (store.Email !== null) {
            $("#email-address").closest(".email").show();
            $("#email-address")
                .attr("href", "mailto:" + store.Email)
                .text(store.Email);
        } else {
            $("#email-address").closest(".email").hide();
        }
        if (store.Phone !== null) {
            $("#phone-number").closest(".phone").show();
            $("#phone-number")
                .attr("href", "tel:" + store.Phone)
                .text(store.Phone);
        } else {
            $("#phone-number").closest(".phone").hide();
        }
    }

    hasNoOpeningHours(openHours: MapStoreOpenHours[]) {
        return (
            openHours === null ||
            openHours === undefined ||
            openHours.findIndex(
                (oh) =>
                    oh.OpeningHour !== "-" &&
                    oh.OpeningHour !== "" &&
                    oh.OpeningHour !== null,
            ) === -1
        );
    }

    hasSameOpeningHoursWeekdays(openHours: MapStoreOpenHours[]) {
        const openingMonday = this.getOpeningTime(openHours, "Mon");
        const closingMonday = this.getClosingTime(openHours, "Mon");
        return (
            this.getOpeningTime(openHours, "Tue") === openingMonday &&
            this.getOpeningTime(openHours, "Wed") === openingMonday &&
            this.getOpeningTime(openHours, "Thu") === openingMonday &&
            this.getOpeningTime(openHours, "Fri") === openingMonday &&
            this.getClosingTime(openHours, "Tue") === closingMonday &&
            this.getClosingTime(openHours, "Wed") === closingMonday &&
            this.getClosingTime(openHours, "Thu") === closingMonday &&
            this.getClosingTime(openHours, "Fri") === closingMonday
        );
    }

    hasSameOpeningHoursWeekend(openHours: MapStoreOpenHours[]) {
        return (
            this.getOpeningTime(openHours, "Sat") ===
                this.getOpeningTime(openHours, "Sun") &&
            this.getClosingTime(openHours, "Sat") ===
                this.getClosingTime(openHours, "Sun")
        );
    }

    hasSameOpeningHoursAllWeek(openHours: MapStoreOpenHours[]) {
        const openingMonday = this.getOpeningTime(openHours, "Mon");
        const closingMonday = this.getClosingTime(openHours, "Mon");
        return (
            openHours.filter((oh) => oh.OpeningHour === openingMonday)
                .length === 7 &&
            openHours.filter((oh) => oh.ClosingHour === closingMonday)
                .length === 7
        );
    }

    hasSameOpeningHoursWeekdaysAndSameWeekend(openHours: MapStoreOpenHours[]) {
        return (
            this.hasSameOpeningHoursWeekdays(openHours) &&
            this.hasSameOpeningHoursWeekend(openHours) &&
            !this.hasSameOpeningHoursAllWeek(openHours)
        );
    }

    getNumberOfOpeningDaySets(store: MapStoreProps) {
        if (this.hasNoOpeningHours(store.OpenHours))
            return this.config.OPENING_HOURS.UNASSIGNED;
        else if (this.hasSameOpeningHoursAllWeek(store.OpenHours))
            return this.config.OPENING_HOURS.SAME_ALL_WEEK;
        else if (
            this.hasSameOpeningHoursWeekdaysAndSameWeekend(store.OpenHours)
        )
            return this.config.OPENING_HOURS.SAME_WEEKDAY_SAME_WEEKEND;
        else if (!this.hasSameOpeningHoursWeekdays(store.OpenHours))
            return this.config.OPENING_HOURS.DIFFERENT_WEEKDAY;
        else return this.config.OPENING_HOURS.SAME_WEEKDAY_DIFFERENT_WEEKEND;
    }

    setStoreDetails(store: MapStoreProps) {
        $("#store-details").show();
        $("#store-details .store-details-close").on("click", function () {
            $("#store-details").hide();
            // this.markers &&
            //     this.markers.forEach((m) => {
            //         m.setIcon(this.markerImageUnselected());
            //     });
        });
        $("#store-name").text(store.StoreName || "");
        $("#store-geo-location")
            .attr(
                "href",
                this.config.GOOGLE_MAPS_BASE_URL +
                    this.utils.toTitleCase(store.Street || "") +
                    "+" +
                    store.Zip +
                    "+" +
                    this.utils.toTitleCase(store.City || ""),
            )
            .attr(
                "aria-label",
                `${store.StoreName} i Google Maps, öppnas i ny flik`,
            )
            .attr(
                "title",
                `${store.StoreName} i Google Maps, öppnas i ny flik`,
            );
    }

    setOpeningDateInfo(store: MapStoreProps, openingPreText: string) {
        if (
            store.ShowOpeningDateInformation &&
            store.OpeningDate &&
            openingPreText &&
            Date.parse(store.OpeningDate) > Date.now()
        ) {
            $("#store-opening-date").show();
            $("#opening-date-information").text(
                openingPreText + " " + store.OpeningDate,
            );
        } else {
            $("#store-opening-date").hide();
            $("#opening-date-information").empty();
        }
    }

    setClosingDateInfo(store: MapStoreProps, closingPreText: string) {
        if (
            store.ShowOpeningDateInformation &&
            store.ClosingDate &&
            closingPreText &&
            Date.parse(store.ClosingDate) > Date.now()
        ) {
            $("#store-closing-date").show();
            $("#closing-date-information").text(
                closingPreText + " " + store.ClosingDate,
            );
        } else {
            $("#store-closing-date").hide();
            $("#closing-date-information").empty();
        }
    }

    getWeekday(weekdayLabel: string) {
        switch (weekdayLabel) {
            case this.config.WEEKDAY_LABELS[0]:
                return "Mon";
            case this.config.WEEKDAY_LABELS[1]:
                return "Tue";
            case this.config.WEEKDAY_LABELS[2]:
                return "Wed";
            case this.config.WEEKDAY_LABELS[3]:
                return "Thu";
            case this.config.WEEKDAY_LABELS[4]:
                return "Fri";
            case this.config.WEEKDAY_LABELS[5]:
                return "Sat";
            case this.config.WEEKDAY_LABELS[6]:
                return "Sun";
            default:
                return "";
        }
    }

    getHours(timeString: string | undefined | null) {
        return timeString && this.isOpen(timeString)
            ? timeString.split(/[\s:,;]+/)[0]
            : null;
    }

    getMinutes(timeString: string, returnZeros = false) {
        if (this.isOpen(timeString)) {
            const minutes = timeString.split(/[\s:,;]+/)[1];
            return returnZeros || minutes !== "00" ? minutes : "";
        } else {
            return "";
        }
    }

    isOpen(timeString: string) {
        return (
            timeString !== null &&
            timeString !== undefined &&
            timeString.trim() !== "" &&
            timeString.trim() !== "-"
        );
    }

    getSpecialDay(day: MapStoreSpecialHours) {
        if (day.Description === null || day.Description.trim() === "") {
            const date = new Date(day.Date.substring(0, 10));

            return date.toLocaleDateString(this.config.WEEKDAY_LANGUAGE, {
                month: "long",
                day: "numeric",
            });
        } else {
            return day.Description;
        }
    }

    getSpecialHours(day: MapStoreSpecialHours) {
        if (!day.IsClosed) {
            const openingHr = this.getHours(day.OpeningHour);
            const closingHr = this.getHours(day.ClosingHour);
            const openingMin = this.getMinutes(day.OpeningHour, true);
            const closingMin = this.getMinutes(day.ClosingHour, true);

            return (
                openingHr +
                ":" +
                openingMin +
                " - " +
                closingHr +
                ":" +
                closingMin
            );
        }
        return this.config.CLOSED_LABEL;
    }

    getTimeSpan(openHours: MapStoreOpenHours[], daylabel: string) {
        const openingTime = this.getOpeningTime(openHours, daylabel);
        const closingTime = this.getClosingTime(openHours, daylabel);

        if (openingTime === closingTime || !this.isOpen(openingTime))
            return this.config.CLOSED_LABEL;

        const openingHr = this.getHours(openingTime);
        const closingHr = this.getHours(closingTime);
        const openingMin = this.getMinutes(openingTime, true);
        const closingMin = this.getMinutes(closingTime, true);

        return (
            openingHr + ":" + openingMin + " - " + closingHr + ":" + closingMin
        );
    }

    getOpeningTime(openHours: MapStoreOpenHours[], weekday: string) {
        const dayObject = openHours.find(
            (oh) =>
                this.utils.toTitleCase(oh.Weekday.substring(0, 3)) === weekday,
        );
        return dayObject ? dayObject.OpeningHour : "";
    }

    getClosingTime(openHours: MapStoreOpenHours[], weekday: string) {
        const dayObject = openHours.find(
            (oh) =>
                this.utils.toTitleCase(oh.Weekday.substring(0, 3)) === weekday,
        );
        return dayObject ? dayObject.ClosingHour : "";
    }
}

export default MapStore;
